import { render, staticRenderFns } from "./userTable.vue?vue&type=template&id=35834cfa&scoped=true"
import script from "./userTable.vue?vue&type=script&lang=ts"
export * from "./userTable.vue?vue&type=script&lang=ts"
import style0 from "./userTable.vue?vue&type=style&index=0&id=35834cfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35834cfa",
  null
  
)

export default component.exports